import '../../Styles/ReusableComponents/miniLoader.scss';

function MiniLoader() {
  return (
    <div className='mini-loader-container'>
      <span className="mini-loader"></span>
    </div>
  )
}

export default MiniLoader